.temp {
  background-color: #ffd;
  color: #383810;
  border-radius: 2px;
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlY2lwZVRlbXBlcmF0dXJlLnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi50ZW1wXG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmRcbiAgY29sb3I6ICMzODM4MTBcbiAgYm9yZGVyLXJhZGl1czogMnB4XG4gIHdoaXRlLXNwYWNlOiBub3dyYXBcbiJdfQ== */